import { DEFAULT_LANGUAGE, LANGUAGE_CODES } from '../config/languages';

/**
 * Detect user's preferred language from browser settings
 * @returns {string} Detected language code or default
 */
export const detectBrowserLanguage = () => {
  try {
    // Get browser languages (returns array like ['cs-CZ', 'cs', 'en-US', 'en'])
    const browserLanguages = navigator.languages || [navigator.language];

    // Try to find exact match first (e.g., 'cs', 'en')
    for (const lang of browserLanguages) {
      const langCode = lang.toLowerCase().split('-')[0]; // Extract base language
      if (LANGUAGE_CODES.includes(langCode)) {
        return langCode;
      }
    }

    // No match found, return default
    return DEFAULT_LANGUAGE;
  } catch (error) {
    console.warn('Error detecting browser language:', error);
    return DEFAULT_LANGUAGE;
  }
};
